import { userConstants } from "../_constants"; 
import { userService } from "../_services"; 
import { errorActions } from "./"; 

// Define all action functions first
const login = (username, password) => {
    return (dispatch) => {
        dispatch(request({ username }));

        return userService.login(username, password).then(
            (res) => {
                if (res.error) {
                    dispatch(errorActions.setError(res.message));
                    return Promise.reject(res.message);
                } else {
                    dispatch(success(res.data));
                    return res.data;
                }
            },
            (error) => {
                dispatch(failure(error.message));
                dispatch(errorActions.setError(error.message));
                return Promise.reject(error.message);
            }
        );
    };

    function request(user) {
        return { type: userConstants.LOGIN_REQUEST, user };
    }
    
    function success(user) {
        return { type: userConstants.LOGIN_SUCCESS, user };
    }
    
    function failure(error) {
        return { type: userConstants.LOGIN_FAILURE, error };
    }
};

function logout() {
    userService.logout();
    setTimeout(() => {
        window.location.href = "/";
    }, 100);
    return { type: userConstants.LOGOUT };
}

function getUserInfo() {
    return (dispatch) => {
        userService.getUserInfo()
            .then(({ data }) => {
                dispatch(success(data.data));
                //dispatch(getGeoLocation());
            })
            .catch((error) => console.log(error));
    };

    function success(data) {
        return { type: userConstants.GET_USER_INFO, payload: data };
    }
}

function getGeoLocation() {
    return (dispatch) => {
        userService.getGeoLocation()
            .then(({ data }) => {
                dispatch({ type: userConstants.GET_GEO_LOCATION, payload: data });
            })
            .catch((error) => {
                console.log(error);
            });
    };
}

// Export the userActions object after defining all functions
export const userActions = {
    login,
    logout,
    getUserInfo,
    getGeoLocation,
};